import api from './api'

export default {
  async listarRoles() {
    const response = await api.get('/roles')
    return response.data
  }
}


